// About Page Translations
export const aboutTranslations = {
  en: {
    // Header
    pageTitle: 'About SubifyHub',
    pageSubtitle: 'We make premium digital services affordable and accessible to everyone. Here\'s our story.',

    // Who We Are Section
    whoWeAreTitle: 'Who We Are',
    whoWeAreDesc: 'We help people access premium digital services at affordable prices by offering carefully curated subscription plans at discounted rates. Our mission is to bridge the gap between expensive premium tools and those who need them most—students, freelancers, professionals, and small teams.',

    // The Problem We Solve Section
    problemTitle: 'The Problem We Solve',
    problemHighCostsTitle: 'High Costs',
    problemHighCostsDesc: 'Many premium platforms offer powerful features, but their high subscription costs make them inaccessible for most people.',
    problemTrustTitle: 'Trust Issues',
    problemTrustDesc: 'Users worry about the legitimacy of discounted services and whether their data is truly secure.',

    // Our Solution Section
    solutionTitle: 'Our Solution',
    solutionIntro: 'We solve this by partnering with verified providers, leveraging bulk plans, and optimizing subscription usage to pass savings directly to our users. Our approach is completely legal, transparent, and ethical.',
    solutionPoint1: 'Partner with verified, legitimate subscription providers',
    solutionPoint2: 'Negotiate volume discounts and pass them on to you',
    solutionPoint3: 'Operate with minimal overhead to reduce costs',
    solutionPoint4: 'Prioritize transparency in every transaction',

    // Why Our Prices Are Lower Section
    pricesTitle: 'Why Our Prices Are Lower',
    pricesSubtitle: 'We\'re transparent about how we keep costs down',
    pricesDigitalOpsTitle: 'Digital Operations',
    pricesDigitalOpsDesc: 'No physical offices or overhead means we can pass savings to you',
    pricesNegotiationsTitle: 'Smart Negotiations',
    pricesNegotiationsDesc: 'Bulk purchasing power and strategic partnerships reduce costs',
    pricesOptimizationTitle: 'Optimization',
    pricesOptimizationDesc: 'Efficient subscription management maximizes value for everyone',

    // What Makes Us Different Section
    differenceTitle: 'What Makes Us Different',
    differenceGenuineTitle: '100% Genuine',
    differenceGenuineDesc: 'All subscriptions are authentic and verified',
    differenceInstantTitle: 'Instant Activation',
    differenceInstantDesc: 'Get access within minutes of purchase',
    differenceSecureTitle: 'Secure Payments',
    differenceSecureDesc: 'Bank-level encryption for all transactions',
    differenceSupportTitle: '24/7 Support',
    differenceSupportDesc: 'Dedicated team ready to help anytime',
    differenceCancelTitle: 'Cancel Anytime',
    differenceCancelDesc: 'No hidden fees or lock-in contracts',

    // Who We're For Section
    forTitle: 'Who We\'re For',
    forSubtitle: 'If you fit any of these categories, you\'re our ideal user',
    forStudentsTitle: 'Students',
    forStudentsDesc: 'Access premium tools at student-friendly prices',
    forProfessionalsTitle: 'Professionals',
    forProfessionalsDesc: 'Upgrade your toolkit without breaking the bank',
    forStartupsTitle: 'Startups',
    forStartupsDesc: 'Scale efficiently with affordable solutions',
    forFreelancersTitle: 'Freelancers',
    forFreelancersDesc: 'Professional tools for competitive pricing',

    // Mission & Vision Section
    missionTitle: 'Our Mission',
    missionDesc: 'To make premium digital tools affordable and accessible to everyone, regardless of their financial situation or background.',
    visionTitle: 'Our Vision',
    visionDesc: 'To become the world\'s most trusted marketplace for affordable digital subscriptions, empowering millions to access opportunity.',

    // Security & Transparency Section
    securityTitle: 'Security & Transparency',
    securityBankTitle: 'Bank-Level Security',
    securityBankDesc: 'All payments are processed through secure, PCI-DSS compliant gateways',
    securityPrivacyTitle: 'Data Privacy',
    securityPrivacyDesc: 'We never store your sensitive financial information on our servers',
    securityPartnersTitle: 'Verified Partnerships',
    securityPartnersDesc: 'All our providers are verified and legitimate subscription platforms',
    securityReportTitle: 'Transparency Report',
    securityReportDesc: 'We publish regular updates on our operations and customer satisfaction rates',

    // Testimonials Section
    testimonialsTitle: 'Customer Success Stories',
    testimonialsSubtitle: 'Helping people save, one subscription at a time',
    testimonials: [
      {
        name: 'Ananya M.',
        role: 'Student',
        text: 'I got my Coursera Plus subscription for half the price! This platform is a lifesaver for students like me.',
      },
      {
        name: 'Rohit K.',
        role: 'Content Creator',
        text: 'The process was so simple, and the deal I got for Netflix saved me over €100 this year!',
      },
      {
        name: 'James P.',
        role: 'Freelancer',
        text: 'Buying a discounted VPN subscription was the best decision. Excellent deals and fast service!',
      },
    ],

    // Core Values Section
    valuesTitle: 'Our Core Values',
    valueAffordabilityTitle: 'Affordability',
    valueAffordabilityDesc: 'Making premium services accessible for everyone',
    valueQualityTitle: 'Quality',
    valueQualityDesc: 'Partnering with leading platforms to provide genuine subscriptions',
    valueTrustTitle: 'Trust',
    valueTrustDesc: 'Transparent pricing and reliable customer support',
    valueInnovationTitle: 'Innovation',
    valueInnovationDesc: 'Bringing you exclusive deals tailored to your digital needs',

    // CTA Section
    ctaTitle: 'Ready to Start Saving?',
    ctaSubtitle: 'Say goodbye to expensive subscriptions. Explore our deals today and unlock the best digital services at affordable prices.',
    ctaButton: 'See Our Deals',
  },

  fr: {
    // Header
    pageTitle: 'À Propos de SubifyHub',
    pageSubtitle: 'Nous rendons les services numériques premium abordables et accessibles à tous. Voici notre histoire.',

    // Who We Are Section
    whoWeAreTitle: 'Qui Sommes-Nous',
    whoWeAreDesc: 'Nous aidons les gens à accéder à des services numériques premium à des prix abordables en proposant des forfaits d\'abonnement soigneusement sélectionnés à des tarifs réduits. Notre mission est de combler le fossé entre les outils premium coûteux et ceux qui en ont le plus besoin—les étudiants, les indépendants, les professionnels et les petites équipes.',

    // The Problem We Solve Section
    problemTitle: 'Le Problème Que Nous Résolvons',
    problemHighCostsTitle: 'Coûts Élevés',
    problemHighCostsDesc: 'De nombreuses plateformes premium offrent des fonctionnalités puissantes, mais leurs coûts d\'abonnement élevés les rendent inaccessibles pour la plupart des gens.',
    problemTrustTitle: 'Problèmes de Confiance',
    problemTrustDesc: 'Les utilisateurs s\'inquiètent de la légitimité des services à prix réduit et de savoir si leurs données sont vraiment sécurisées.',

    // Our Solution Section
    solutionTitle: 'Notre Solution',
    solutionIntro: 'Nous résolvons cela en partenariat avec des fournisseurs vérifiés, en exploitant les plans en volume et en optimisant l\'utilisation des abonnements pour transmettre les économies directement à nos utilisateurs. Notre approche est entièrement légale, transparente et éthique.',
    solutionPoint1: 'Partenariat avec des fournisseurs d\'abonnement vérifiés et légitimes',
    solutionPoint2: 'Négocier les remises en volume et les transmettre à vous',
    solutionPoint3: 'Opérer avec des frais généraux minimaux pour réduire les coûts',
    solutionPoint4: 'Donner la priorité à la transparence dans chaque transaction',

    // Why Our Prices Are Lower Section
    pricesTitle: 'Pourquoi Nos Prix Sont Plus Bas',
    pricesSubtitle: 'Nous sommes transparents sur la façon dont nous maintenons les coûts bas',
    pricesDigitalOpsTitle: 'Opérations Numériques',
    pricesDigitalOpsDesc: 'Pas de bureaux physiques ni de frais généraux signifie que nous pouvons transmettre les économies à vous',
    pricesNegotiationsTitle: 'Négociations Intelligentes',
    pricesNegotiationsDesc: 'La puissance d\'achat en volume et les partenariats stratégiques réduisent les coûts',
    pricesOptimizationTitle: 'Optimisation',
    pricesOptimizationDesc: 'La gestion efficace des abonnements maximise la valeur pour tous',

    // What Makes Us Different Section
    differenceTitle: 'Ce Qui Nous Rend Différents',
    differenceGenuineTitle: '100% Authentique',
    differenceGenuineDesc: 'Tous les abonnements sont authentiques et vérifiés',
    differenceInstantTitle: 'Activation Instantanée',
    differenceInstantDesc: 'Accédez en quelques minutes après l\'achat',
    differenceSecureTitle: 'Paiements Sécurisés',
    differenceSecureDesc: 'Chiffrement de niveau bancaire pour toutes les transactions',
    differenceSupportTitle: 'Support 24/7',
    differenceSupportDesc: 'L\'équipe dévouée prête à aider à tout moment',
    differenceCancelTitle: 'Annuler à Tout Moment',
    differenceCancelDesc: 'Pas de frais cachés ni de contrats de verrouillage',

    // Who We're For Section
    forTitle: 'Pour Qui Sommes-Nous',
    forSubtitle: 'Si vous remplissez l\'une de ces catégories, vous êtes notre utilisateur idéal',
    forStudentsTitle: 'Étudiants',
    forStudentsDesc: 'Accédez aux outils premium à des prix adaptés aux étudiants',
    forProfessionalsTitle: 'Professionnels',
    forProfessionalsDesc: 'Améliorez votre boîte à outils sans vous ruiner',
    forStartupsTitle: 'Startups',
    forStartupsDesc: 'Échelle efficacement avec des solutions abordables',
    forFreelancersTitle: 'Indépendants',
    forFreelancersDesc: 'Outils professionnels à des prix compétitifs',

    // Mission & Vision Section
    missionTitle: 'Notre Mission',
    missionDesc: 'Rendre les outils numériques premium abordables et accessibles à tous, indépendamment de leur situation financière ou de leurs antécédents.',
    visionTitle: 'Notre Vision',
    visionDesc: 'Devenir la marketplace la plus fiable au monde pour les abonnements numériques abordables, autonomisant des millions de personnes pour accéder à l\'opportunité.',

    // Security & Transparency Section
    securityTitle: 'Sécurité et Transparence',
    securityBankTitle: 'Sécurité de Niveau Bancaire',
    securityBankDesc: 'Tous les paiements sont traités via des passerelles sécurisées conformes aux normes PCI-DSS',
    securityPrivacyTitle: 'Confidentialité des Données',
    securityPrivacyDesc: 'Nous ne stockeons jamais vos informations financières sensibles sur nos serveurs',
    securityPartnersTitle: 'Partenariats Vérifiés',
    securityPartnersDesc: 'Tous nos fournisseurs sont vérifiés et sont des plateformes d\'abonnement légitimes',
    securityReportTitle: 'Rapport de Transparence',
    securityReportDesc: 'Nous publions régulièrement des mises à jour sur nos opérations et nos taux de satisfaction client',

    // Testimonials Section
    testimonialsTitle: 'Histoires de Réussite des Clients',
    testimonialsSubtitle: 'Aider les gens à économiser, un abonnement à la fois',
    testimonials: [
      {
        name: 'Ananya M.',
        role: 'Étudiante',
        text: 'J\'ai obtenu mon abonnement Coursera Plus pour moitié prix! Cette plateforme est une bouée de sauvetage pour les étudiants comme moi.',
      },
      {
        name: 'Rohit K.',
        role: 'Créateur de Contenu',
        text: 'Le processus était si simple, et l\'offre que j\'ai obtenue pour Netflix m\'a fait économiser plus de 100 € cette année!',
      },
      {
        name: 'James P.',
        role: 'Indépendant',
        text: 'Acheter un abonnement VPN à prix réduit était la meilleure décision. D\'excellentes offres et un service rapide!',
      },
    ],

    // Core Values Section
    valuesTitle: 'Nos Valeurs Fondamentales',
    valueAffordabilityTitle: 'Accessibilité',
    valueAffordabilityDesc: 'Rendre les services premium accessibles pour tous',
    valueQualityTitle: 'Qualité',
    valueQualityDesc: 'Partenariat avec les principales plateformes pour fournir des abonnements authentiques',
    valueTrustTitle: 'Confiance',
    valueTrustDesc: 'Tarification transparente et support client fiable',
    valueInnovationTitle: 'Innovation',
    valueInnovationDesc: 'Vous apporter des offres exclusives adaptées à vos besoins numériques',

    // CTA Section
    ctaTitle: 'Prêt à Commencer à Économiser?',
    ctaSubtitle: 'Dites adieu aux abonnements coûteux. Explorez nos offres aujourd\'hui et débloquez les meilleurs services numériques à des prix abordables.',
    ctaButton: 'Voir Nos Offres',
  },
};

export const useAboutTranslations = (language = 'en') => {
  return aboutTranslations[language] || aboutTranslations['en'];
};
